export default __webpack_public_path__ + "static/media/chip_50.8a149f2b.svg";